<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-start">
    <div class="modal-title">Collect Additional Information</div>
  </div>
  <div class="modal-body" [formGroup]="option">
    <mdb-form-control class="form-fill">
      <app-mdbp-input mdbInput formControlName="name"  label='Question'></app-mdbp-input>
      <span class="form-fill-error"  *ngIf="option.controls.name.hasError('required') && option.controls.name.touched">Please provide Name</span>
    </mdb-form-control>

    <mdb-form-control class="form-fill">
      <mdb-select formControlName="type" class="mdb-select">
        <mdb-option *ngFor="let type of types" [value]="type.id">{{type.label}}</mdb-option>
      </mdb-select>
      <label mdbLabel class="form-label form-label--paybee">Answer Type</label>
      <span class="form-fill-error" *ngIf="option.controls.type.hasError('required') && option.controls.type.touched">Please provide Type</span>
    </mdb-form-control>
    
    <div *ngIf="option.value.type == 2">
        <p class="mb-0 grey-text small">
            Type a option and press enter to add. Click <strong>X</strong> to remove it.
        </p>
        <app-chips 
          placeholder="Selection Options" 
          formControlName="options"
          [required]="true"                       
          [touched]="optionsControl.touched"
        ></app-chips>
    </div>

    <div class="divider"></div>

    <app-mdb-switch label="Required Field" formControlName="required"></app-mdb-switch>
    <app-mdb-switch label="To be added by Admin" formControlName="toBeAddedBy"></app-mdb-switch>

    <div class="divider"></div>
    <div class="position-relative mb-4">
      <label class="form-check-label form-check-label--paybee mb-1 mt-3">Description (optional)</label>
      <mdb-form-control class="mb-4">     
        <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
      </mdb-form-control>
    </div>
    <div class="divider"></div>
  </div>
  <div class="modal-footer modal-footer--form-field">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="confirm(dialog, option.value)">Confirm</button>
      </div>
    </div>
  </div>  
</ng-container>
